<div class="modal-content-container">
  <div class="messages">
    <div class="messages-list" ng-include="'user/messages/messages-list-partial.tpl.html'"></div>
  </div>
</div>
